import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Service } from '../services';
import { GlobalService } from '../global.service';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { Subscription } from "rxjs";
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-subscriberdetail',
  templateUrl: './subscriberdetail.component.html',
  styleUrls: ['./subscriberdetail.component.sass']
})
export class SubscriberdetailComponent implements OnInit {
  public tabActive = 'Dashboard';
  public selectBan;
  public info;
  public itemImageField;
  public itemDescriptionField;
  public techField;
  public installmentValueField;
  public installmentsField;
  public sOCDescriptionField;
  public socRateField;
  public sOCDescriptionInfoField;
  public servSVAsField;
  public totalRateField;
  public minutesUsageField;
  public lDUsageField;
  public lDIUsageField;
  public sMSUSageField;
  public sMSPremiunUsageField;
  public mMSUsageField;
  public itemBrandField;
  public cuentaP;
  public subscriberP;
  public productType;
  public dateWarranty;
  public token: string = sessionStorage.getItem("token");
  public index = 0;
  public ini: boolean = false;
  public typeAccount;
  loadObserver: Subscription;

  constructor(public appComponent: AppComponent, private loadingScreenService: LoadingScreenService, private services: Service, private global: GlobalService, public AngularFireAnalytics: AngularFireAnalytics) {
    this.AngularFireAnalytics.setCurrentScreen("Detalle del Suscriptor");
    this.AngularFireAnalytics.logEvent("Detalle del Suscriptor-Screenview");
  }

  ngOnInit() {
    this.global.validateSession();
    this.loadingScreenService.startLoading();
    this.cuentaP = atob(sessionStorage.getItem("account_B"));
    this.subscriberP = atob(sessionStorage.getItem("subscriber_B"));
    this.global.refreshDataTo(this.token, this.cuentaP, this.subscriberP);
    this.loadObserver = this.global.loadObserver.subscribe((data: object) => {
      this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
      for (let i = 0; i < this.info.length; i++) {
        if (this.info[i].subscriberNumberField == this.subscriberP) {
          this.index = i;
          this.itemImageField = this.info[i].equipmentInfoField.itemImageField;
          this.itemDescriptionField = this.info[i].equipmentInfoField.itemDescriptionField;
          this.techField = this.info[i].equipmentInfoField.techField;
          this.itemBrandField = this.info[i].equipmentInfoField.itemBrandField;
          this.installmentValueField = this.info[i].equipmentInfoField.installmentValueField;
          this.installmentsField = this.info[i].equipmentInfoField.installmentsField;
          this.sOCDescriptionField = this.info[i].planInfoField.sOCDescriptionField;
          this.socRateField = this.info[i].planInfoField.socRateField;
          this.sOCDescriptionInfoField = this.info[i].planInfoField.sOCDescriptionInfoField;
          this.servSVAsField = this.info[i].servSVAInfoField.servSVAsField;
          this.totalRateField = this.info[i].planInfoField.totalRateField;
          this.minutesUsageField = this.info[i].usageInfoField.minutesUsageField;
          this.lDUsageField = this.info[i].usageInfoField.lDUsageField;
          this.lDIUsageField = this.info[i].usageInfoField.lDIUsageField;
          this.sMSUSageField = this.info[i].usageInfoField.sMSUSageField;
          this.sMSPremiunUsageField = this.info[i].usageInfoField.sMSPremiunUsageField;
          this.mMSUsageField = this.info[i].usageInfoField.mMSUsageField;
          this.productType = this.info[i].productTypeField;
          this.ini = true;
          this.typeAccount=this.global.checkProductType(this.productType);
        }
      }
      this.loadingScreenService.startLoading();
      //7875171050
      this.services.warrantyStatus(this.subscriberP).subscribe(data => {
        this.loadingScreenService.stopLoading();
        if (data != null) {
           this.dateWarranty=data.warrantyReclamationDate;
        }
        else{
          this.dateWarranty='';
        }
      },
      error => {

      }
      );
    });
    this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
  }
}